var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useRequest } from "../../hooks/useRequest";
import { dateFilterValuesGenerator, generateQueryParams } from "../../utils";
export var useWorkspaceUsage = function () {
    var request = useRequest();
    var _a = useState(null), usageDashboardData = _a[0], setUsageDashboardData = _a[1];
    var _b = useState(false), isLoadingUsageDashboard = _b[0], setIsLoadingUsageDashboard = _b[1];
    // Get usage dashboard data with detailed breakdown
    var getUsageDashboard = function (filter, flowId, callFlowId, customStartDate, customEndDate, includeOutbound, includeDirectTransfers, caller, page, pageSize, sortBy, sortDir) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 50; }
        if (sortBy === void 0) { sortBy = "CallStart"; }
        if (sortDir === void 0) { sortDir = "desc"; }
        return __awaiter(void 0, void 0, void 0, function () {
            var timeZone, dateFilter, queryParams, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoadingUsageDashboard(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        dateFilter = dateFilterValuesGenerator(filter, customStartDate, customEndDate);
                        queryParams = generateQueryParams(__assign(__assign({}, dateFilter), { timeZone: timeZone, flowId: flowId, callFlowId: callFlowId, includeOutbound: includeOutbound, includeDirectTransfers: includeDirectTransfers, caller: caller, page: page, pageSize: pageSize, sortBy: sortBy, sortDir: sortDir }));
                        return [4 /*yield*/, request.get("/WorkspaceUsageDashboard/usage?".concat(queryParams))];
                    case 2:
                        response = _a.sent();
                        setUsageDashboardData(response.data);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Failed to fetch usage dashboard data:", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoadingUsageDashboard(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Get usage dashboard data and return it directly (for AG-Grid datasource)
    var getUsageDashboardData = function (filter, flowId, callFlowId, customStartDate, customEndDate, includeOutbound, includeDirectTransfers, caller, page, pageSize, sortBy, sortDir) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 50; }
        if (sortBy === void 0) { sortBy = "CallStart"; }
        if (sortDir === void 0) { sortDir = "desc"; }
        return __awaiter(void 0, void 0, void 0, function () {
            var timeZone, dateFilter, queryParams, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        dateFilter = dateFilterValuesGenerator(filter, customStartDate, customEndDate);
                        queryParams = generateQueryParams(__assign(__assign({}, dateFilter), { timeZone: timeZone, flowId: flowId, callFlowId: callFlowId, includeOutbound: includeOutbound, includeDirectTransfers: includeDirectTransfers, caller: caller, page: page, pageSize: pageSize, sortBy: sortBy, sortDir: sortDir }));
                        return [4 /*yield*/, request.get("/WorkspaceUsageDashboard/usage?".concat(queryParams))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Failed to fetch usage dashboard data:", error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Export usage dashboard data as CSV
    var exportUsageDashboardCSV = function (filter, flowId, callFlowId, customStartDate, customEndDate, includeOutbound, includeDirectTransfers, caller, sortBy, sortDir) {
        if (sortBy === void 0) { sortBy = "CallStart"; }
        if (sortDir === void 0) { sortDir = "desc"; }
        return __awaiter(void 0, void 0, void 0, function () {
            var timeZone, dateFilter, queryParams, response, contentDisposition, filename, filenameMatch, blob, url, a, error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        dateFilter = dateFilterValuesGenerator(filter, customStartDate, customEndDate);
                        queryParams = generateQueryParams(__assign(__assign({}, dateFilter), { timeZone: timeZone, flowId: flowId, callFlowId: callFlowId, includeOutbound: includeOutbound, includeDirectTransfers: includeDirectTransfers, caller: caller, sortBy: sortBy, sortDir: sortDir }));
                        return [4 /*yield*/, request.get("/WorkspaceUsageDashboard/usage/export?".concat(queryParams), { responseType: 'blob' })];
                    case 1:
                        response = _b.sent();
                        contentDisposition = (_a = response.headers) === null || _a === void 0 ? void 0 : _a['content-disposition'];
                        filename = 'workspace-usage-export.csv';
                        if (contentDisposition) {
                            filenameMatch = contentDisposition.match(/filename="(.+)"/);
                            if (filenameMatch) {
                                filename = filenameMatch[1];
                            }
                        }
                        blob = new Blob([response.data], { type: 'text/csv' });
                        url = window.URL.createObjectURL(blob);
                        a = document.createElement('a');
                        a.href = url;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                        return [2 /*return*/, { success: true, filename: filename }];
                    case 2:
                        error_3 = _b.sent();
                        console.error("Failed to export usage dashboard CSV:", error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return {
        // Usage dashboard
        usageDashboardData: usageDashboardData,
        isLoadingUsageDashboard: isLoadingUsageDashboard,
        getUsageDashboard: getUsageDashboard,
        getUsageDashboardData: getUsageDashboardData,
        // CSV export
        exportUsageDashboardCSV: exportUsageDashboardCSV,
        // Request object for direct API calls
        request: request,
    };
};
